
import RcDomainObject from '@/domain/common/RcDomainObject.js';

export default class RcError extends RcDomainObject {
  
  static Fields = {
      MessageId: "messageId",
      Hint: "hint",
  }
  
  static Values = {
      MessageIds: {
        InvoiceAlreadyPaid: "InvoiceAlreadyPaidId", 
        // A checklist save that kept the edit but could not record its frozen version.
        ChecklistVersionNotSaved: "ChecklistVersionNotSavedId",
        // A save refused because it would change a built-in checklist (HTTP 403).
        ChecklistBuiltInLocked: "ChecklistBuiltInLockedId",
        // A save, copy or removal refused because the checklist is a government schedule
        // (ClickUp 86e3mpnkr, release 3; HTTP 403, RC admins included).
        ChecklistScheduleLocked: "ChecklistScheduleLockedId",
        ChecklistNoteLocked: "ChecklistNoteLockedId",
        ChecklistNeedsCompany: "ChecklistNeedsCompanyId",
        ChecklistItemLocked: "ChecklistItemLockedId",
        ChecklistOtherCompany: "ChecklistOtherCompanyId",
        // Rollup checklist questions (ClickUp 86e3p7nzw), all HTTP 400 on CheckListSave.
        ChecklistRollupNeedsQuestions: "ChecklistRollupNeedsQuestionsId",
        ChecklistRollupQuestionType: "ChecklistRollupQuestionTypeId",
        ChecklistRollupNeedsAnswers: "ChecklistRollupNeedsAnswersId",
        ChecklistRollupNeedsGood: "ChecklistRollupNeedsGoodId",
        ChecklistRollupAnswers: "ChecklistRollupAnswersId",
        ChecklistRollupSharedAnswer: "ChecklistRollupSharedAnswerId",
        ChecklistRollupDisplay: "ChecklistRollupDisplayId",
        ChecklistDisplay: "ChecklistDisplayId",
      },
  }
  
  constructor(domain, data) {
    super(domain, data);
  }
  
  messageId() {
    return this.getString(RcError.Fields.MessageId);
  }

  withMessageId(messageId) {
    this.put(RcError.Fields.MessageId, messageId);
    return this;
  }

  hint() {
    return this.getString(RcError.Fields.Hint);
  }
  
  withHint(hint) {
    this.put(RcError.Fields.Hint, hint);
    return this;
  }
  
  isInvoiceAlreadyPaid() {
    var messageId = this.getString(RcError.Fields.MessageId);
    return RcError.Values.MessageIds.InvoiceAlreadyPaid == messageId; 
  }

  isChecklistVersionNotSaved() {
    return RcError.Values.MessageIds.ChecklistVersionNotSaved == this.messageId();
  }

  isChecklistScheduleLocked() {
    return RcError.Values.MessageIds.ChecklistScheduleLocked == this.messageId();
  }

  isChecklistBuiltInLocked() {
    return RcError.Values.MessageIds.ChecklistBuiltInLocked == this.messageId();
  }

  isChecklistNoteLocked() {
    return RcError.Values.MessageIds.ChecklistNoteLocked == this.messageId();
  }

  isChecklistNeedsCompany() {
    return RcError.Values.MessageIds.ChecklistNeedsCompany == this.messageId();
  }

  isChecklistItemLocked() {
    return RcError.Values.MessageIds.ChecklistItemLocked == this.messageId();
  }

  isChecklistOtherCompany() {
    return RcError.Values.MessageIds.ChecklistOtherCompany == this.messageId();
  }

  isChecklistRollupNeedsQuestions() {
    return RcError.Values.MessageIds.ChecklistRollupNeedsQuestions == this.messageId();
  }

  isChecklistRollupQuestionType() {
    return RcError.Values.MessageIds.ChecklistRollupQuestionType == this.messageId();
  }

  isChecklistRollupNeedsAnswers() {
    return RcError.Values.MessageIds.ChecklistRollupNeedsAnswers == this.messageId();
  }

  isChecklistRollupNeedsGood() {
    return RcError.Values.MessageIds.ChecklistRollupNeedsGood == this.messageId();
  }

  isChecklistRollupAnswers() {
    return RcError.Values.MessageIds.ChecklistRollupAnswers == this.messageId();
  }

  isChecklistRollupSharedAnswer() {
    return RcError.Values.MessageIds.ChecklistRollupSharedAnswer == this.messageId();
  }

  isChecklistRollupDisplay() {
    return RcError.Values.MessageIds.ChecklistRollupDisplay == this.messageId();
  }

  isChecklistDisplay() {
    return RcError.Values.MessageIds.ChecklistDisplay == this.messageId();
  }
}
